
import './EditFormParentControls.scss';
import Switch from '@mui/material/Switch';
import rq from 'components/RedQuick';
import TitleService from 'title-service';
export default function EditFormParentControls(props: {
    isChild: boolean,
    birthDate: any,
    onBirthDateChange: (args: any) => void,
    onChange: (args: boolean) => void
}) {
    return (
        <div className="sc-hAXbOi byLymV ">
            <div className="header header--section-header padding--top-1 padding--right-4 padding--bottom-1 padding--left-4">
                <p className="body-copy margin--0 truncate text-color--section-header">{TitleService('Parental Controls')}</p>
            </div>
            <div className="sc-fihHvN sc-fObBmV kTlczo">
                <label
                    aria-label={TitleService(`Toggle kids mode on or off for this profile. Kids mode is currently set to ${props.isChild}.`)}
                    aria-pressed={props.isChild} htmlFor="kidsMode"
                    className="sc-gleUXh cfqHiD form-label" tabIndex={0}
                    style={{
                        flexDirection: 'row', justifyContent: 'space-between', margin: '0px auto 8px'
                    }}>
                    <p className="body-copy margin--0 text-color--primary margin--left-2 margin--right-2">{TitleService(`Kids Profile`)}</p>
                    <div className="sc-doWzTn fleBqB">
                        <div>

                            <Switch checked={props.isChild || false} onChange={(evt, checked) => {
                                props.onChange(checked);
                            }} name="kidsMode" id="kidsMode" inputProps={{ 'aria-label': props.isChild ? 'checked' : 'unchecked' }} />
                            <span htmlFor="kidsMode" className="sc-hdPSEv bHUKIO">
                            </span>
                        </div>
                    </div>
                </label>
                <div className="metadata text--left text-color--secondary">{TitleService('A profile with curated content and features, and a simplified user interface.')}</div>
            </div>
            <div className="sc-fihHvN sc-fObBmV kTlczo">
                <label
                    aria-label={TitleService(`${props.isChild}.`)}
                    aria-pressed={props.isChild} htmlFor="birthDate"
                    className="sc-gleUXh cfqHiD form-label" tabIndex={0}
                    style={{
                        flexDirection: 'row', justifyContent: 'space-between', margin: '0px auto 8px'
                    }}>
                    <p className="body-copy margin--0 text-color--primary margin--left-2 margin--right-2">{TitleService(`Kids Profile`)}</p>
                    <div className="sc-doWzTn fleBqB">
                        <div>

                            <rq.RedQuickDatePicker title={TitleService('Birth Date')}
                                disabled={!(props.isChild)}
                                value={props.birthDate || new Date()} onChange={(val) => {
                                    console.log('updated');
                                    try {
                                        props.onBirthDateChange(val.toISOString());
                                    } catch (e) {
                                        console.error(e);
                                    }
                                }} />
                            <span htmlFor="birthDate" className="sc-hdPSEv bHUKIO">
                            </span>
                        </div>
                    </div>
                </label>
            </div>
        </div>
    );
}